import { InjectionToken } from '@angular/core';

export const INITIAL_ROUTE = new InjectionToken<string>('vn-am-initial-route');
